// extracted by mini-css-extract-plugin
module.exports = {"chatButton":"Chat_pc_chatButton__xnR7F","button":"Chat_pc_button__1cUA5"};